import { SYSTEM_ERROR } from "../../src/config/CONSTANT";
import axios from "axios";
import packageJson from "../../package.json";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;
export const getAllStaffDeleted = () => {
  return new Promise((resolve, reject) => {
    try {
      axios
        .get(`${BaseUrl}/api/getDeletedStaff`, {
          withCredentials: true,
        })
        .then((res) => {
          resolve(res.data.data);
        })

        .catch((err) => {
          reject("Error in getAllTrips axios!");
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};
